import React, { useEffect } from "react";
import { TextField, Autocomplete } from "@mui/material";
import { useState } from "react";

// const statusOption = ["PUBLISHED", "APPROVED", "REPLACED", "DELETED", "FAIL"];

/**
 *
 * @param {*} param0
 * @returns
 * version 1.1
 * Default variant or functions:
 * - disabled
 * - value
 * - onChange
 *
 * Customise variant of functions
 * label: lable of TextField Autocomple
 * filter = (options) => option.condition : filter option display
 * getOptionLabel = {(option) => option.display customize}
 * getDataFunction {() => api to get data }
 * triggerSetDefaultFunc = {condition to filter value in option}
 * getDataDependencies = {[value for api filter]}
 * setDefaultDependencies={[default value for api filter]}
 *
 */

export const FilterBy = ({
  variant,
  filter = () => true, // ham filter data, vd filter={item => item.id === 3} => chi hien nhung data co id = 3
  setDefaultFunc = () => true, // ham setState cua component cha
  triggerSetDefaultFunc = false, // dependencies cua effect set default func
  label, // label cua textfield
  getDataFunc = () => true, // thuong la ham axios de lay du lieu
  triggerGetDataFunc = true, // dependencies cua effect get data func
  clearStateOnUnmount, // neu = true thi data ben trong state se bi xoa khi component unmount, nen dung khi luu state trong redux tam thoi
  getDataDependencies = [],
  setDefaultDependencies = [],
  inputProps,
  ...autocompleteProps
}) => {
  const [data, setLocalData] = useState(null);
  const [allow, setAllow] = useState(true);
  const clearData = () => {
    setLocalData(null);
  };
  const getData = () => {
    try {
      clearData();
      getDataFunc()?.then((res) => {
        if (res.code === 200) {
          return setData(res.data);
        }
        if (res.code === 403) {
          setAllow(false);
        }
      });
    } catch (error) {
      console.error("getData error", error);
    }
  };
  const setData = (data) => {
    setLocalData(data);
  };
  const setDefault = () => {
    try {
      setDefaultFunc(data, data);
    } catch (error) {
      console.error("lỗi khi setDefault", error);
    }
  };
  useEffect(() => {
    if (triggerGetDataFunc) getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...getDataDependencies, triggerGetDataFunc]);

  useEffect(() => {
    if (triggerSetDefaultFunc && data) setDefault();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...setDefaultDependencies, data, triggerSetDefaultFunc]);

  return (
    <Autocomplete
      isOptionEqualToValue={(option, value) => option?.id === value?.id || option.id === value}
      loading={!data}
      loadingText={allow ? "Loading..." : "No permission"}
      options={data?.filter(filter) || []}
      getOptionLabel={(option) => `${option.id} - ${option.name}` || ""}
      renderInput={(params) => <TextField {...params} variant={variant || "outlined"} label={label} InputLabelProps={{ shrink: true }} inputProps={{ ...params.inputProps, ...inputProps }} />}
      {...autocompleteProps}
      multiple={data ? autocompleteProps.multiple : false}
      value={data ? autocompleteProps.value || (autocompleteProps.multiple ? [] : null) : null}
    />
  );
};
JSON.isParseable = (string) => {
  try {
    JSON.parse(string);
  } catch (error) {
    return false;
  }
  return true;
};
